import { isCanlan } from './customer-name'

/* Felipe Nunes: Updated Wed, 18 Oct 2024 10:15PM ( BRT ) */
// If it fails (like if the previously set hardcoded token is expired)
// try setting the hardcoded token again (hopefully a new one)
// {
//   "access_token": "v2.local.2g-qXVIooKAC0B04Z1j-wFLnEjzXg8CYEdLkYxuqF-piTdG6-Ya9zwk7tKm12UpUD3sPZJpmQJu-f1sbU0Yz-mVzF3GdXK_SrYQA3d-HucTAOV8m70m2mEj8RqVKl2sn9JICR65AD-9-qRuE6fuG-q7cRJsBKZx164Y-QxYtmI-pF_gVD0LdC2FbsI8a_Ep3NoOriyK47jtCIgMYibu209fHwWGpwAo4c1L07F04qsAn9KyX-XNZYpDaRhXr0aWIOsexTj3Vs2luAPDmlgRUbYoLRaacNnU",
//   "token_type": "Bearer",
//   "expires_in": 604800,
//   "expires_at": "2024-10-26T01:14:01.561409Z",
//   "user": {
//     "id": "TAcc3KT6ikeaqhvL",
//     "email": "michael+planeticeservice@sportninja.com",
//     "created_at": "2022-08-29T23:14:34+00:00",
//     "updated_at": "2024-10-19T01:13:49+00:00",
//     "validated_at": "2022-08-29T23:14:42+00:00"
//   }
// }
const planetIceToken =
  'v2.local.2g-qXVIooKAC0B04Z1j-wFLnEjzXg8CYEdLkYxuqF-piTdG6-Ya9zwk7tKm12UpUD3sPZJpmQJu-f1sbU0Yz-mVzF3GdXK_SrYQA3d-HucTAOV8m70m2mEj8RqVKl2sn9JICR65AD-9-qRuE6fuG-q7cRJsBKZx164Y-QxYtmI-pF_gVD0LdC2FbsI8a_Ep3NoOriyK47jtCIgMYibu209fHwWGpwAo4c1L07F04qsAn9KyX-XNZYpDaRhXr0aWIOsexTj3Vs2luAPDmlgRUbYoLRaacNnU'

// {
//   "access_token": "v2.local.j8dQwSQZhlCDdFRcQieNLta4XK8Dnke1hxZbzsJ025BFhUps0NUY5iIc1M05TzN37bYeUI0Tzzz7bXn4EGbDhC59NWO_rBksA7-IHWs9hvIgxQgbTGoaodeZZHna75O2IvmfRA-iSj8khJyhHmhQMh49oenmamof6Av3civlhAN1g91sNgYfiwqCx8y_jIhA0NVDpAchTIfH8NJeSU4bk7ToWtnmxkjTJLvtjf_KdhIO6c7w_ta5Y-8i8VNpxw4FTysQisUsl1zlonFDshcMLvYYZnFxl4A",
//   "token_type": "Bearer",
//   "expires_in": 604800,
//   "expires_at": "2024-10-26T01:16:00.695693Z",
//   "user": {
//     "id": "oP37ysYCd57bFlkj",
//     "email": "michael+carhaservice@sportninja.com",
//     "created_at": "2022-05-27T18:35:59+00:00",
//     "updated_at": "2024-10-19T01:15:50+00:00",
//     "validated_at": "2022-05-27T18:35:59+00:00"
//   }
// }
const carhaToken =
  'v2.local.j8dQwSQZhlCDdFRcQieNLta4XK8Dnke1hxZbzsJ025BFhUps0NUY5iIc1M05TzN37bYeUI0Tzzz7bXn4EGbDhC59NWO_rBksA7-IHWs9hvIgxQgbTGoaodeZZHna75O2IvmfRA-iSj8khJyhHmhQMh49oenmamof6Av3civlhAN1g91sNgYfiwqCx8y_jIhA0NVDpAchTIfH8NJeSU4bk7ToWtnmxkjTJLvtjf_KdhIO6c7w_ta5Y-8i8VNpxw4FTysQisUsl1zlonFDshcMLvYYZnFxl4A'

// {
//   "access_token": "v2.local.8MK2XbHGt6Y7k8_8gj1Yq-tItc5z_AlGuVUXa5BgCA5ZNxLepdC9hlWmn7QDOq0zZrWYOLKpkM7Xg3usBaIoutVhCJTfkeRTgx87hvpBljtHa8oatoF8aK5Xj0BlZF31OcP-9fN1YvOg_9ToNa9Cs3vtpuf6KjWq8EyVcaODfzqhpouQAhqz-HV6252btvjfKO3_6aaMix9Id7yme2KdhNIk57bBBVja_2mz1-77YSKpB-7D10c9oUlq6pb2Dx0BXInXMSM4n73yxgGNO6CrkiTYa4wu",
//   "token_type": "Bearer",
//   "expires_in": 604800,
//   "expires_at": "2024-10-26T01:17:23.215619Z",
//   "user": {
//     "id": "jJkc8qSsffa24rAE",
//     "email": "michael+canlanservice@sportninja.com",
//     "created_at": "2022-05-30T20:39:26+00:00",
//     "updated_at": "2023-05-19T19:59:44+00:00",
//     "validated_at": "2022-05-30T20:39:26+00:00"
//   }
// }
const canlanToken =
  'v2.local.8MK2XbHGt6Y7k8_8gj1Yq-tItc5z_AlGuVUXa5BgCA5ZNxLepdC9hlWmn7QDOq0zZrWYOLKpkM7Xg3usBaIoutVhCJTfkeRTgx87hvpBljtHa8oatoF8aK5Xj0BlZF31OcP-9fN1YvOg_9ToNa9Cs3vtpuf6KjWq8EyVcaODfzqhpouQAhqz-HV6252btvjfKO3_6aaMix9Id7yme2KdhNIk57bBBVja_2mz1-77YSKpB-7D10c9oUlq6pb2Dx0BXInXMSM4n73yxgGNO6CrkiTYa4wu'

export const getIframeToken = () => {
  const parentUrl =
    window.location !== window.parent.location
      ? window?.document?.referrer
      : window?.document?.location?.href

  let isPlanetIce = false
  if (parentUrl && parentUrl.includes('pacificadulthockey.com')) {
    isPlanetIce = true
  }
  return isCanlan ? canlanToken : isPlanetIce ? planetIceToken : carhaToken
}
